// Dependencies
import React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import VehicleCardDesktopSkeleton from "./VehicleCardDesktop/VehicleCardDesktop.skeleton";
import VehicleCardMobileSkeleton from "./VehicleCardMobile/VehicleCardMobile.skeleton";

const VehicleCardSkeleton = () => {
  const largeCard = useMediaQuery("(min-width:600px)");

  return (
    <>
      {largeCard ? (
        <VehicleCardDesktopSkeleton />
      ) : (
        <VehicleCardMobileSkeleton />
      )}
    </>
  );
};

export default VehicleCardSkeleton;
